// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"JewelsToolbar_Toolbar__-zb5D","Right":"JewelsToolbar_Right__5xNJG"};